import React from 'react';
import { FadeIn } from './FadeIn';
const collections = [{
  id: 1,
  name: 'קולקציית פנינים',
  gradient: 'from-[#fdfbf7] to-[#f0ece1]'
}, {
  id: 2,
  name: 'זהב ורד',
  gradient: 'from-[#fdf8f6] to-[#f4e6e0]'
}, {
  id: 3,
  name: 'יהלומי פחם',
  gradient: 'from-[#f5f5f5] to-[#e0e0e0]'
}];
export function Collections() {
  return <section id="collections" className="py-32 md:py-48" data-id="element-44">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-45">
        <FadeIn data-id="element-46">
          <div className="flex items-center justify-between mb-24" data-id="element-47">
            <h2 className="serif text-4xl md:text-5xl text-charcoal" data-id="element-48">
              קולקציות
            </h2>
            <a href="#" className="label-tiny text-charcoal/60 hover:text-gold transition-colors duration-500" data-id="element-49">
              צפו בכל הפריטים
            </a>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-50">
          {collections.map((item, index) => <FadeIn key={item.id} delay={index * 0.2} className="group cursor-pointer" data-id="element-51">
              <div className="relative aspect-[3/4] overflow-hidden mb-8 bg-white" data-id="element-52">
                <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-80 group-hover:scale-105 transition-transform duration-[1.5s] ease-[0.16,1,0.3,1]`} data-id="element-53" />
                {/* Placeholder for actual jewelry image - keeping it abstract/empty for the extreme minimal vibe as requested */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-1000" data-id="element-54">
                  <div className="w-1/3 h-1/3 rounded-full bg-white/20 blur-2xl" data-id="element-55" />
                </div>
              </div>

              <div className="flex flex-col items-center text-center" data-id="element-56">
                <h3 className="label-tiny text-charcoal relative inline-block" data-id="element-57">
                  {item.name}
                  <span className="absolute -bottom-2 left-0 right-0 h-px bg-gold scale-x-0 group-hover:scale-x-100 transition-transform duration-700 origin-right" data-id="element-58" />
                </h3>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}